import { register } from 'register-service-worker'
import store from './stores'

if (process.env.NODE_ENV === 'production' || true) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // console.log('Service worker is active.')
    },
    async registered(registration) {
      // console.log('Service worker has been registered.', store)

      await store.dispatch('setSwRegistration', registration)

      await store.dispatch('extractSubscriptionFromRegistration')
    },
    cached() {
      // console.log('Content has been cached for offline use.')
    },
    updatefound(registration) {
      // console.log('New content is downloading.')
    },
    updated(registration) {
      // console.log('New content is available; please refresh.')
      // document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }))
    },
    offline() {
      // console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      // console.error('Error during service worker registration:', error)
    },
  })
}


